export default __webpack_public_path__ + "static/media/save.1b50e423.svg";